import { Divider } from 'antd';
import styled from 'styled-components';
import { StyledRteTheme } from '../style/StyledRteTheme.tsx';

const StyledMenuDivider = styled(Divider)`
  margin: 0 4px;
  height: 1em;
  border-inline-start-color: ${props =>
    props.theme.colorBorder ?? StyledRteTheme.colorBorder};
`;

export interface RichTextMenuDividerProps {}

export function RichTextMenuDivider(props: RichTextMenuDividerProps) {
  return <StyledMenuDivider type="vertical" />;
}
